import React, { Component, Fragment } from "react";
import { trackReportStyle } from "../../../Reports/Timps/style/index";
import "../../../Reports/Timps/style/style.css";
import { Container, Col, Row, Label, Button, FormGroup } from "reactstrap";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { iconToShow, iconTwoShow } from "../../../Reports/variables";
import _ from "lodash";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { getWhiteSpaces } from "../../../../utils/getWhiteSpaces";
import { tick_char } from "../special-char";
import moment from "moment";
import { SignatureImage } from "../../../Reports/utils/SignatureImage";
import { decodeGtAndLt } from "../../../../utils/utils";

const newProtectionTypeIds = [
  { key: "t841", value: "841" },
  { key: "tocs", value: "OCS" },
  { key: "tsafwat", value: "SAFETY WATCH" },
  { key: "towork", value: "LONE WORKER" },
];

class JobBriefingOntario extends Component {
  constructor(props) {
    super(props);
    this.config = {
      minRows: 5,
    };

    this.state = {
      data: props.data ? props.data : {},
    };
  }

  renderTextAndTick(title, value) {
    return (
      <span className={value ? "active" : ""}>
        <span className="selection-char">{tick_char}</span>
        {title}
      </span>
    );
  }

  render() {
    let { data } = this.state;
    let tbltest = getTabletbltest(data && data.tbltest);
    let tbliop = getTabletbliop(data && data.tbliop);
    const logo1Source = themeService(iconToShow);
    return (
      <React.Fragment>
        <div className="table-report job-briefing-ontario last-page-break-print" style={{ ...themeService(trackReportStyle.mainStyle) }}>
          <Row>
            <Col md={2}>{logo1Source && <img src={logo1Source} alt="Logo" style={{ width: "100%" }} />}</Col>
            <Col md={3}></Col>
            <Col md={7}>
              <h2 style={{ ...themeService(trackReportStyle.headingStyle), textAlign: "right", transform: "none" }}>
                <span>{"RAIL INFRASTRUCTURE JOB BRIEFING"}</span>
                <br />
                <span style={{ fontWeight: "100", fontStyle: "italic" }}>{`${this.props.title}`}</span>
              </h2>
            </Col>
          </Row>
          <hr />
          <table className="table-bordered">
            <tbody>
              <tr>
                <td colSpan={4}>
                  <span className="title-in-report">Date: </span>
                  <span>{data.date ? moment(data.date).format("MM-DD-YYYY") : ""}</span>
                </td>
                <td colSpan={5}>
                  <span className="title-in-report">Employee In Charge: </span>
                  <span>{data.empl}</span>
                </td>
                <td colSpan={4}>
                  <span className="title-in-report">Head Count: </span>
                  <span>{data.hcou}</span>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Work Location(s) and Task(s) to be Performed Today:</div>
                </td>
                <td colSpan={9}>
                  <p className="work-description text-left pd-left-10px">{data.loc2}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">
                    Train Line-Up <small>(if applicable)</small>
                    {":"}
                  </div>
                </td>
                <td colSpan={9}>
                  <p className="work-description text-left pd-left-10px">{data.tline}</p>
                </td>
              </tr>

              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Protection Type: </div>
                </td>
                <td colSpan={5}>
                  <p className={"work-description text-left pd-left-10px text-bold"}>
                    {data.ptype
                      ? data.ptype
                      : newProtectionTypeIds
                          .filter((field) => data[field.key] === true)
                          .map((field) => field.value)
                          .join(`${getWhiteSpaces(5)}|${getWhiteSpaces(5)}`)}
                  </p>
                </td>
                <td colSpan={2}>
                  <div className="title-in-report text-left">Clearance #: </div>
                </td>
                <td colSpan={2}>
                  <p className={"work-description text-left pd-left-10px"}>{data.clear}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Protection Limits Between: </div>
                </td>
                <td colSpan={4}>
                  <p className={"work-description text-left pd-left-10px"}>{data.plb}</p>
                </td>
                <td colSpan={1}>
                  <span className="title-small-report">and</span>
                </td>
                <td colSpan={4}>
                  <p className={"work-description text-left pd-left-10px"}>{data.and}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Communication Info: RTC - Channel 2 #1 TOWER(S):</div>
                </td>
                <td colSpan={9}>
                  <p className={"work-description text-left pd-left-10px"}>{data.towers}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Rule 125 reviewed (Ch. 2 #9)?</div>
                </td>
                <td colSpan={1}>
                  <p className={"work-description text-left pd-left-10px"}>{data.tow}</p>
                </td>
                <td colSpan={8}>
                  <p className={"work-description text-left pd-left-10px"}>{data.tow === "No" && data.open ? data.open : ""}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">
                    Emergency Phone / Radio Persons: <small>(identify person(s))</small>{" "}
                  </div>
                </td>
                <td colSpan={6}>
                  <p className={"work-description text-left pd-left-10px"}>{data.rper}</p>
                </td>
                <td colSpan={1}>
                  <div className="title-in-report text-left">Alt: </div>
                </td>
                <td colSpan={2}>
                  <p className={"work-description text-left pd-left-10px"}>{data.alt}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Rule 110 process in place and reviewed?</div>
                </td>
                <td colSpan={1}>
                  <p className={"work-description text-left pd-left-10px"}>{data.au_no}</p>
                </td>
                <td colSpan={8}>
                  <p className={"work-description text-left pd-left-10px"}>{data.au_no === "No" && data.open1 ? data.open1 : ""}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">
                    First Aid / CPR Persons: <br /> <small>(identify person(s))</small>
                  </div>
                </td>
                <td colSpan={6}>
                  <p className={"work-description text-left pd-left-10px"}>{data.faid}</p>
                </td>
                <td colSpan={1}>
                  <div className="title-in-report text-left">Alt: </div>
                </td>
                <td colSpan={2}>
                  <p className={"work-description text-left pd-left-10px"}>{data.alt1}</p>
                </td>
              </tr>

              <tr>
                <td colSpan={6}>
                  <div className="title-in-report text-left">Location of First Aid Kit(s) Identified?</div>
                </td>
                <td colSpan={1}>
                  <p className={"work-description text-left pd-left-10px"}>
                    {data.hasOwnProperty("yes") && data.yes ? "Yes" : data.locaid}
                  </p>
                </td>
                <td colSpan={4}>
                  <div className="title-in-report text-left">Evacuation Plan Reviewed?</div>
                </td>
                <td colSpan={2}>
                  <p className={"work-description text-left pd-left-10px"}>
                    {data.hasOwnProperty("yes1") && data.yes1 ? "Yes" : data.evacplan}
                  </p>
                </td>
              </tr>
              <tr>
                <td colSpan={6}>
                  <div className="title-in-report text-left">
                    Rule / General Circular / Safety Bulletin of the Week <small>(See schedule - check off)</small> <br />
                    <small>
                      Tip: 1st workday, to be reviewed in its entirety with crew. Thereafter, review a smaller section of information each
                      day.{" "}
                    </small>
                  </div>
                </td>
                <td colSpan={7}>
                  <p className={"work-description text-left pd-left-10px"}>
                    {data.hasOwnProperty("yes2") && data.yes2 ? "Yes" : data.rgcsbw}
                  </p>
                </td>
              </tr>

              <tr>
                <td colSpan={4}>
                  <div className="title-in-report text-left">
                    Signal Maintainer Required? <br /> <small>(if so, name and contact info)</small>
                  </div>
                </td>
                <td colSpan={5} className="text-left">
                  <span className="title-in-report">Name: </span>
                  <span>{data.na ? "N/A" : data.trname}</span>
                </td>
                <td colSpan={4} className="text-left">
                  <span className="title-in-report">Contact: </span>
                  <span>{data.na ? "N/A" : data.tocontin}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <table className="table-bordered values-circle ">
            <tbody>
              <tr>
                <td colSpan={9}>
                  <span className="title-in-report">Hand / Power Tools Required and Inspected</span>
                </td>
                <td colSpan={3}>{this.renderTextAndTick("Adze", data.adze)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Backpack Blower", data.bblow)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Brush Saw", data.bsaw)}</td>
              </tr>
              <tr>
                <td colSpan={3}>{this.renderTextAndTick("Chain Saw", data.csaw)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Claw Bar", data.cbar)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Drift Pins", data.dpins)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Hand Tamper", data.htamp)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Level Board", data.lboar)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Lining Bar", data.lbar)}</td>
              </tr>
              <tr>
                <td colSpan={3}>{this.renderTextAndTick("Pick", data.pick)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Pick Pole", data.polo)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Pipe Wrench", data.pwren)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Plank Drill", data.pdrill)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Power Track Wrench", data.ptwre)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Rail Bender", data.rbend)}</td>
              </tr>
              <tr>
                <td colSpan={3}>{this.renderTextAndTick("Rail Drill", data.rdril)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Rail Fork", data.rfork)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Rail Saw", data.rsaw)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Rail Tongs", data.rtong)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Rake", data.rake)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Sledge Hammer", data.shame)}</td>
              </tr>
              <tr>
                <td colSpan={3}>{this.renderTextAndTick("Snow Shovel", data.snowsho)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Spike Maul", data.spike)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Spike Puller", data.spikepul)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Spike Starter", data.spikestar)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Switch Brooms", data.broom)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Tamping Bar", data.tampbar)}</td>
              </tr>
              <tr>
                <td colSpan={3}>{this.renderTextAndTick("Tie Plug Punch", data.tppug)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Tie Tongs", data.ttong)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Tommy Bar", data.tom)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Track Chisel", data.chisel)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Track Gauge", data.tgage)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Track Jack", data.tjack)}</td>
              </tr>
              <tr>
                <td colSpan={3}>{this.renderTextAndTick("Track Shovel", data.tshov)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Track Wrench", data.tren)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Signals Multi-Meter", data.mmeter)}</td>
                <td colSpan={3}>{this.renderTextAndTick("Small Hand Tools", data.handtol)}</td>
                <td colSpan={4}></td>
              </tr>
              <tr>
                <td colSpan={6}>
                  <span className="title-in-report">Pre-Trip Inspection Completed?</span>
                </td>
                <td colSpan={3}>{data.inspecomp}</td>
                <td colSpan={9}>{data.inspecomp === "No" && data.open2 ? data.open2 : ""}</td>
              </tr>
            </tbody>
          </table>
          <table className="table-bordered table-bordered">
            <thead>
              <tr>
                <td colSpan={20} className="dark-bg">
                  {data.na3 && <span className="haeading-na"> ( N/A ) </span>}

                  <span className={data.na3 ? "main-heading-in-rpt na" : "main-heading-in-rpt"}>DISTANCE TO STOP TEST(S)</span>
                  <br />
                  <small>
                    This must be performed by all hi-rail and work equipment the first time you track travel each day and when rail
                    conditions changes.
                  </small>
                </td>
              </tr>
              <tr>
                <th colSpan={2}>Unit#</th>
                <th colSpan={5}>Location</th>
                <th colSpan={1}>Time</th>
                <th colSpan={2}>Speed</th>
                <th colSpan={5}>Distance to Stop</th>
                <th colSpan={5}>Rail Condition</th>
              </tr>
            </thead>
            <tbody>
              {tbltest}
              {addEmptyColsIfNotEnough(tbltest, this.config.minRows, 1)}
            </tbody>
          </table>
        </div>

        <div
          className="table-report job-briefing-ontario risk-assessment last-page-break-print"
          style={{ ...themeService(trackReportStyle.mainStyle) }}
        >
          <Row>
            <Col md={2}>{logo1Source && <img src={logo1Source} alt="Logo" style={{ width: "100%" }} />}</Col>
            <Col md={3}></Col>
            <Col md={7}>
              <h2 style={{ ...themeService(trackReportStyle.headingStyle), textAlign: "right", transform: "none" }}>
                <span>{"RAIL INFRASTRUCTURE JOB BRIEFING"}</span>
                <br />
                <span style={{ fontWeight: "100", fontStyle: "italic" }}>{`${this.props.title}`}</span>
              </h2>
            </Col>
          </Row>
          <hr />
          <table className="table-bordered background-dark values-circle" style={{ marginBottom: "0" }}>
            <thead>
              <tr>
                <td colSpan={3} className="dark-bg">
                  <span className="main-heading-in-rpt">FIELD LEVEL RISK ASSESSMENT</span>
                </td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <h5> HAZARD EXAMPLES</h5>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{this.renderTextAndTick("Access / Egress", data.access)}</td>
                <td>{this.renderTextAndTick("Heavy Lifting / Material Handling", data.heavy)}</td>
                <td>{this.renderTextAndTick("Sharp Surfaces", data.sharp)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Animals / Insects", data.anime)}</td>
                <td>{this.renderTextAndTick("Ice", data.ice)}</td>
                <td>{this.renderTextAndTick("Sightlines", data.sightline)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Awkward Positions (ergonomics)", data.postma)}</td>
                <td>{this.renderTextAndTick("Inexperienced Workers", data.inexp)}</td>
                <td>{this.renderTextAndTick("Slips / Trips / Falls", data.stfa)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Chemicals", data.chem)}</td>
                <td>{this.renderTextAndTick("Lone Worker", data.wlone)}</td>
                <td>{this.renderTextAndTick("Struck By / Against", data.sturckb)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Cranes / Rigging", data.cranesr)}</td>
                <td>{this.renderTextAndTick("Mobile Equipment", data.mobic)}</td>
                <td>{this.renderTextAndTick("Structural Failure", data.sfail)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Dehydration", data.dehyd)}</td>
                <td>{this.renderTextAndTick("Night Work", data.wnight)}</td>
                <td>{this.renderTextAndTick("Train(s)", data.train)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Dust / Flying Particles", data.dust)}</td>
                <td>{this.renderTextAndTick("Noise Obstructions", data.noise)}</td>
                <td>{this.renderTextAndTick("Underground Utilities", data.underg)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Electrocution", data.electuc)}</td>
                <td>{this.renderTextAndTick("Open Holes", data.access)}</td>
                <td>{this.renderTextAndTick("Uneven Surfaces / Rough Terrain", data.hopen)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Equipment Blind Spots", data.blind)}</td>
                <td>{this.renderTextAndTick("Other Work Groups", data.wgrop)}</td>
                <td>{this.renderTextAndTick("UV Exposure", data.uvexpo)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Falling Objects", data.fobj)}</td>
                <td>{this.renderTextAndTick("Overhead Power Lines", data.overhead)}</td>
                <td>{this.renderTextAndTick("Vibration", data.vibra)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Fatigue", data.fatik)}</td>
                <td>{this.renderTextAndTick("Pinch Points", data.pinch)}</td>
                <td>{this.renderTextAndTick("Weather", data.weath)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Fire", data.fire45)}</td>
                <td>{this.renderTextAndTick("Public Interaction", data.puninta)}</td>
                <td>{this.renderTextAndTick("Working at Heights", data.heiwor)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Hazardous Materials", data.hazmat)}</td>
                <td>{this.renderTextAndTick("Remote Location", data.remoloc)}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table className="table-bordered background-light values-circle" style={{ marginBottom: "0" }}>
            <thead>
              <tr>
                <td colSpan={3}>CONTROLS / PPE EXAMPLES</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{this.renderTextAndTick("500' Travelling Distance", data.travel5)}</td>
                <td>{this.renderTextAndTick("Flags / Signage", data.signage)}</td>
                <td>{this.renderTextAndTick("Stretching / Warm-Up Excercies", data.warmup)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("40' Work Space", data.wspace)}</td>
                <td>
                  {this.renderTextAndTick(
                    <Fragment>
                      Job Briefing w/ RTC or Foreman <br /> (complete "Lone Worker" form if Hazard 18)
                    </Fragment>,
                    data.jobrif,
                  )}
                </td>
                <td>{this.renderTextAndTick("Substitute the Object", data.stob)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("3-Point Contact", data.cpoint)}</td>
                <td>{this.renderTextAndTick("Locates", data.locates)}</td>
                <td>{this.renderTextAndTick("Traffic Control", data.tc900)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Aerial Devices", data.adev)}</td>
                <td>{this.renderTextAndTick("Policies / Procedures / Practices", data.ppp410)}</td>
                <td>{this.renderTextAndTick("Training / Education", data.tedu)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Barriers / Guards / Covers", data.bguard)}</td>
                <td>{this.renderTextAndTick("Protection (OCS, 841)", data.pro841)}</td>
                <td>{this.renderTextAndTick("Travel Restraint", data.trvwacz)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Bump Cap / Hard Hat", data.bumpcap)}</td>
                <td>{this.renderTextAndTick("Protective Gloves", data.pglow)}</td>
                <td>{this.renderTextAndTick("Ventilation", data.ventil)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Equipment Inspection", data.inspequ)}</td>
                <td>{this.renderTextAndTick("Radio Communication", data.radiocom)}</td>
                <td>{this.renderTextAndTick("Work Area Control Zone", data.wacaz)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Eye Protection", data.eyeprot)}</td>
                <td>{this.renderTextAndTick("Safety Watch / Spotter (complete “Safety Watch” form)", data.spoter)}</td>
                <td>{this.renderTextAndTick("Work on Ground vs. At Heights", data.wagah)}</td>
              </tr>
              <tr>
                <td>{this.renderTextAndTick("Fire Prevention / Suppression Equipment", data.fprevt)}</td>
                <td>{this.renderTextAndTick("Site Inspection", data.sinspe)}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <table className="table-bordered" style={{ marginBottom: "10px" }}>
            <thead>
              <tr>
                <td colSpan={21} className="dark-bg">
                  {data.na5 && <span className="haeading-na"> ( N/A ) </span>}
                  <span className={data.na5 ? "main-heading-in-rpt na" : "main-heading-in-rpt"}>
                    INDUSTRIAL OPERATIONS PROTOCOL <small>(during fire season)</small>
                  </span>
                  <br />
                  <small>See “Steps to Work with the Industrial Operations Protocol” at back of booklet</small>
                </td>
              </tr>
              <tr>
                <th colSpan={4}>Description of Operation</th>
                <th colSpan={5}>Equipment Required</th>
                <th colSpan={2}>
                  Stoniness <br />
                  <small></small>
                </th>
                <th colSpan={2}>
                  Fire Risk <br />
                  <small></small>{" "}
                </th>
                <th colSpan={2}>
                  Fuel Group <br />
                  <small>(+/- modifier)</small>
                </th>
                <th colSpan={2}>
                  Fire Intensity <br />
                  Code
                  <small></small>
                </th>
                <th colSpan={2}>
                  NOT Trained <br />& Capable{" "}
                </th>
                <th colSpan={2}>
                  Trained & <br />
                  Capable
                </th>
              </tr>
            </thead>
            <tbody>
              {tbliop}
              {addEmptyColsIfNotEnough(tbliop, 4, 2)}
              <tr>
                <td className="force-sig-new-height" colSpan={21} style={{ textAlign: "left" }}>
                  <span className="signature-heading-in-table">Crew Signatures: </span>
                  <p style={{ minHeight: "100px" }}> {renderSignatures(this.props.workers)}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <table style={{ marginBottom: "10px" }}>
            <thead>
              <tr>
                <td colSpan={19} className="dark-bg">
                  <span className="main-heading-in-rpt">
                    DEBRIEFING<small> (to be conducted at end of each work days – check off and complete) </small>
                  </span>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={9}>
                  <div className="title-in-report text-left">
                    Has the work area been cleaned up, tools inspected after use and stored properly?{" "}
                  </div>
                </td>
                <td colSpan={1}> {data.hwbcp}</td>
                <td colSpan={9}>
                  <div className="text-left pd-left-10px">{data.hwbcp === "No" && data.open5 ? data.open5 : ""}</div>
                </td>
              </tr>
              <tr>
                <td colSpan={9}>
                  <div className="title-in-report text-left">Have all switches been restored to normal</div>
                </td>
                <td colSpan={1}> {data.hasrn}</td>
                <td colSpan={9}>
                  <div className="text-left pd-left-10px">{data.hasrn === "No" && data.open6 ? data.open6 : ""}</div>
                </td>
              </tr>
              <tr>
                <td colSpan={9}>
                  <div className="title-in-report text-left">Notes / Planning / Signal Maintainer Required Next Day? / Improvements / </div>
                </td>
                <td colSpan={10}>
                  <div className="text-left pd-left-10px">{data.pnotes}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </React.Fragment>
    );
  }
}
export default JobBriefingOntario;

function addEmptyColsIfNotEnough(mapArray = [], minRows, type) {
  let emptyRows = null;
  let mapArrayLength = mapArray ? mapArray.length : 0;
  let countToAdd = minRows - mapArrayLength;

  if (countToAdd > 0) {
    emptyRows = [];
    for (let i = 0; i < countToAdd; i++) {
      let row = <tr>{getCols(type)}</tr>;
      emptyRows.push(row);
    }
  }

  return emptyRows;
}
function getCols(type) {
  let cols = [];
  let span = [];
  if (type == 2) span = [4, 5, 2, 2, 2, 2, 2, 2];
  else span = [2, 5, 1, 2, 5, 5];
  for (let i = 0; i < span.length; i++) {
    cols.push(<td colSpan={span[i]}></td>);
  }
  return cols;
}

function getActiveCheckBox(data, field) {
  return data && data[field] ? "active" : "";
}

function matchValueActiveClass(data, field, matchField) {
  return data && data[field] === matchField ? " active" : "";
}

function getTabletbltest(tbltest) {
  let toRet = null;
  if (tbltest && tbltest.length > 0) {
    toRet = tbltest
      .filter((item) => item)
      .map((tbltestObj) => {
        return (
          <tr className="small-font">
            <td colSpan={2}>
              <small>{tbltestObj.unitno}</small>
            </td>
            <td colSpan={5}>
              <small>{tbltestObj.loco}</small>
            </td>
            <td colSpan={1}>
              <small>{tbltestObj.timo}</small>
            </td>
            <td colSpan={2}>
              <small>{tbltestObj.speedo}</small>
            </td>
            <td colSpan={5}>
              <small>{tbltestObj.dts}</small>
            </td>
            <td colSpan={5}>
              <small>{tbltestObj.rcond}</small>
            </td>
          </tr>
        );
      });
  }
  return toRet;
}

function getTabletbliop(tbliop) {
  let toRet = null;
  if (tbliop && tbliop.length > 0) {
    toRet = tbliop
      .filter((item) => item)
      .map((tbliopObj) => {
        return (
          <tr>
            <td colSpan={4}>{tbliopObj.doper}</td>
            <td colSpan={5}>{tbliopObj.reqequi}</td>
            <td colSpan={2}>{decodeGtAndLt(tbliopObj.stonin)}</td>
            <td colSpan={2}>{tbliopObj.frisk}</td>
            <td colSpan={2}>{tbliopObj.fuel}</td>
            <td colSpan={2}>{tbliopObj.fic}</td>
            <td colSpan={2}>{tbliopObj.ntac}</td>
            <td colSpan={2}>{tbliopObj.taco}</td>
          </tr>
        );
      });
  }
  return toRet;
}

export function renderSignatures(workersObjs, style) {
  let workers = workersObjs ? workersObjs : [];
  let toRet = null;
  if (workers.length > 0) {
    toRet = workers
      .filter((w) => w && typeof w === "object" && !w.isRemoved)
      .map((worker) => {
        if (!worker.type) {
          return (
            <SignatureImage
              signatureImage={worker.signature && !worker.byPhone ? worker.signature.imgName : null}
              userName={!worker.byPhone ? worker.name : `${worker.name} (By Phone)`}
              sigIsOptional={true}
              overRideContainerStyle={style ? style : null}
            />
          );
        } else return null;
      });
  }
  return <div className="multi-signatures">{toRet}</div>;
}



// WEBPACK FOOTER //
// ./src/components/jobBriefing/JobBrieifingReport/Ontario/JobBriefingOntario.jsx